import { AppBar, Box, Button, Toolbar, Typography } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, urlOrigin: window.location.origin };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  backToHome() {
    const { urlOrigin } = this.state;
    window.location.href = urlOrigin;
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      return (
        <Box className="container-fluid jvs-p-t15">
          <AppBar position="static" color="default" className="jvs-bg-blue position-fixed jvs-t">
            <Toolbar className="d-flex justify-content-between jvs-header align-items-center jvs-p-cont pb-1">
              <Box>
                <Typography color="white" sx={{ fontSize: "11px !important" }}>
                  バイトするなら【エントリー】
                </Typography>
                <Box sx={{ display: "flex" }} onClick={() => this.backToHome()}>
                  <Box
                    component="img"
                    sx={{
                      width: 40,
                    }}
                    alt="logo image"
                    src="/img/logo-entry.png"
                  />
                  <Box
                    component="img"
                    sx={{
                      width: 165,
                      ml: -2,
                    }}
                    alt="logo text"
                    src="/img/logo-text.png"
                  />
                </Box>
              </Box>
            </Toolbar>
          </AppBar>
          <main className="h-100">
            <Box className="text-center mt-4" sx={{ p: 2 }}>
              <Typography variant="h4">すみません、問題が発生しました。</Typography>
              <Typography className="mt-3">できる限り早く直すために、取り組んでいます。</Typography>
              <Button
                className="jvs-btn-gray mt-3"
                sx={{ width: "auto" }}
                onClick={() => this.backToHome()}
              >
                ホーム画面に戻ります。
              </Button>
            </Box>
          </main>
        </Box>
      );
    }
    return children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node,
};
